import React, { useState } from 'react';
import { Alert, Button, Checkbox, message, Modal, Space, Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

export default function SecretRevealModal({ open, data, onClose }) {
    const [acknowledged, setAcknowledged] = useState(false);

    const handleClose = () => {
        setAcknowledged(false);
        onClose();
    };

    const copy = (value, label) => {
        navigator.clipboard?.writeText(value)
            .then(() => message.success(`${label} copied`))
            .catch(() => message.error('Copy failed'));
    };

    if (!data) return null;

    return (
        <Modal
            title="Application Secret"
            open={open}
            closable={false}
            maskClosable={false}
            keyboard={false}
            footer={[
                <Button key="ok" type="primary" disabled={!acknowledged} onClick={handleClose}>
                    I have saved the secret
                </Button>
            ]}
        >
            <Alert
                type="warning"
                showIcon
                message="This secret will not be shown again."
                description="Copy it somewhere safe. If you lose it, rotate the secret from the app's row."
                style={{ marginBottom: 16 }}
            />
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <div>
                    <Text type="secondary">app_id</Text>
                    <Paragraph copyable={{ text: data.app_id }} style={{ fontFamily: 'monospace', marginBottom: 0 }}>
                        {data.app_id}
                    </Paragraph>
                </div>
                <div>
                    <Text type="secondary">app_secret</Text>
                    <Paragraph style={{ fontFamily: 'monospace', marginBottom: 0, wordBreak: 'break-all' }}>
                        {data.app_secret}{' '}
                        <Button
                            size="small"
                            icon={<CopyOutlined />}
                            onClick={() => copy(data.app_secret, 'app_secret')}
                        >
                            Copy
                        </Button>
                    </Paragraph>
                </div>
                <Checkbox
                    checked={acknowledged}
                    onChange={(e) => setAcknowledged(e.target.checked)}
                >
                    I have saved the secret in a safe place.
                </Checkbox>
            </Space>
        </Modal>
    );
}
